export const omit = (keys, obj) => Object.keys(obj).reduce((acc, cur) => {
  if (keys.includes(cur)) {
    return acc
  }
  return { ...acc, [cur]: obj[cur] }
}, {})
